<template>
  <component v-if="component"
    :is="component"
    :locale="locale"
    :id="id"
    :moduleIndex="moduleIndex"
    :item="item"
    :itemSetting="itemSetting"
    :activeLang="activeLang"
    :hasPrice="hasPrice"
    :subOption="subOption"
    @setDetail="setDetails" />
</template>

<script>
export default {
  name: 'Modules',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting',
    'subOption'
  ],
  computed: {
    loader () {
      const mods = this.item.type
      const module = mods.replace(/\b\w/g, l => l.toUpperCase())
      if (!mods) {
        return null
      }
      return () => import(`./${module}.vue`)
    }
  },
  data () {
    return {
      component: null
    }
  },
  mounted () {
    this.loader()
      .then(() => {
        this.component = () => this.loader()
      })
      .catch(() => {
        this.component = null
      })
  },
  methods: {
    setDetails (detail) {
      this.$emit('setDetail', detail)
    }
  }
}
</script>
